import BlockList from './BlockList.vue';

export default BlockList;
